import Routes from './Routes.js';
new Routes();